import * as types from '../mutation-types';

// Utilities
import { addNoScroll, removeNoScroll } from '@/utilities';

// initial state
const state = {
  hasDrawer: false,
  isDrawerActive: false,
};

// mutations
const mutations = {
  [types.SET_DRAWER](state, bool) {
    state.hasDrawer = bool;
  },

  [types.SET_DRAWER_ACTIVE](state, bool) {
    state.isDrawerActive = bool;
  },
};

const actions = {
  setDrawerState: ({ commit }, bool) => {
    commit(types.SET_DRAWER, bool);
  },

  openDrawer: ({ commit, dispatch }, setScrollTo = null) => {
    setTimeout(() => {
      // Using setTimeout avoids iOS Safari drawer display bug. Not ideal, but solves the issue for now
      addNoScroll(setScrollTo);
    }, 100);

    commit(types.SET_DRAWER_ACTIVE, true);

    setTimeout(() => {
      dispatch('prependQueueToFeed');
    }, 1000);
  },

  closeDrawer: ({ commit, dispatch, rootState, state }) => {
    if (state.isDrawerActive) {
      let isFiltersEnabled = !!rootState.feed.filters.gameTypes.find(function (gameType) {
        // Look for at least one instance of an enabled gameType
        return gameType.enabled;
      });

      if (isFiltersEnabled) {
        dispatch('disableAllGameTypeFilters');
      } else {
        //dispatch('prependQueueToFeed');
      }

      removeNoScroll();
      commit(types.SET_DRAWER_ACTIVE, false);
    }
  }
};

const getters = {
  drawer(state) {
    return state;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/modules/drawer.js